import React from 'react';
import Navbar from '../components/navbar';


export default function Project() {
  return (
    <>
    <Navbar/>
    <div className="project_container">
    <nav aria-label="breadcrumb">
  <ol className="breadcrumb">
    <li className="breadcrumb-item " aria-current="page">Home</li>
    <li className="breadcrumb-item active" aria-current="page">Project</li>
  </ol>
</nav>
    </div>

    </>
  )
}
